export type ProductListSortingOption = {
  label: string;
  value: string;
};

export const enum ProductListFilterValues {
  ON_SALE = 'on-sale',
  NEW_RELEASE_DISCOUNT = 'new-release-discount',
  QUICK_START_BUNDLE = 'quick-start-bundle',
  ON_SALE_SOON = 'on-sale-soon',
  PUBLISHER_OF_THE_WEEK = 'publisher-of-the-week',
}

export const enum ProductListSortValues {
  POPULARITY = 'popularity',
  RATING = 'rating',
  PUBLISHED_DATE = 'published-date',
  RECENTLY_UPDATED = 'recently-updated',
  PRICE_LOW_TO_HIGH = 'price-low-to-high',
  PRICE_HIGH_TO_LOW = 'price-high-to-low',
}

export type ProductListSortingPropsMicrocopy = {
  filterAriaLabel: string;
  sortAriaLabel: string;
  filterPlaceholder: string;
  sortPlaceholder: string;
  mobileButtonLabel: string;
  mobileCloseAriaLabel: string;
  mobileFilterTitle: string;
  mobileSortTitle: string;
  mobileViewResultsLabel: string;
  mobileClearLabel: string;
  filterOptions: string[];
  sortOptions: string[];
};

export type ProductListSortingPropsData = {
  selectedSort: string | null;
  selectedFilters: string[];
  resultsCount?: number;
};

export type ProductListSortingPropsDataWithMicrocopy =
  ProductListSortingPropsData & {
    microcopy: ProductListSortingPropsMicrocopy;
  };

export type ProductListSortingPropsActions = {
  onSortChange: (value: string) => void;
  onFiltersChange: (values: string[]) => void;
  onClear: () => void;
};

export type ProductListSortingProps = ProductListSortingPropsDataWithMicrocopy &
  ProductListSortingPropsActions & {
    className?: string;
  };
